import { ChangeDetectionStrategy, Component } from '@angular/core'

import { BaseIconComponent } from '../base-icon.component'

@Component({
  selector: 'app-icon-users-1',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 13.1667C2.5 11.694 3.694 10.5 5.16667 10.5H7.83333C9.306 10.5 10.5 11.694 10.5 13.1667"
        [attr.stroke]="color"
        style="stroke-opacity:1;"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.1665 4.26733C12.0872 4.26733 12.8332 5.01333 12.8332 5.934C12.8332 6.85467 12.0872 7.60067 11.1665 7.60067"
        [attr.stroke]="color"
        style="stroke-opacity:1;"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.10349 4.49734C8.98894 5.38278 8.98894 6.81838 8.10349 7.70383C7.21804 8.58928 5.78244 8.58928 4.897 7.70383C4.01155 6.81838 4.01155 5.38278 4.897 4.49734C5.78244 3.61189 7.21804 3.61189 8.10349 4.49734"
        [attr.stroke]="color"
        style="stroke-opacity:1;"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8335 9.83325C13.3062 9.83325 14.5002 11.0273 14.5002 12.4999"
        [attr.stroke]="color"
        style="stroke-opacity:1;"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Users1IconComponent extends BaseIconComponent {}
